import React, { memo } from "react";
import useFilterToolbar from "./index.hooks";
import { Grid, IconButton, Toolbar } from "@material-ui/core";
import { DateRangeFilter } from "../../components";
import { DeleteSweep } from "@material-ui/icons";
import { DateFilterTypes } from "../../redux-store/slices/stats/interfaces";

type FilterToolbarProps = {};

const FilterToolbar = ({}: FilterToolbarProps) => {
  const {
    styles,
    classes,
    atomicStyles,
    t,
    handleResetFilters,
    dateFilterType,
  } = useFilterToolbar();

  const renderClearFiltersButton = () => {
    return (
      <IconButton size="small" color="primary" onClick={handleResetFilters}>
        <DeleteSweep />
      </IconButton>
    );
  };

  return (
    <Toolbar>
      <Grid container spacing={2}>
        <Grid item>
          <DateRangeFilter />
        </Grid>
        <Grid item>
          {dateFilterType !== DateFilterTypes.LAST_30_DAYS &&
            renderClearFiltersButton()}
        </Grid>
      </Grid>
    </Toolbar>
  );
};

export default memo(FilterToolbar);
